import React, { useState } from 'react';
import { Input, Box, RadioGroup, Radio, Select, T, Checkbox, DatePicker, Textarea } from '@veracity/vui';
import ImageUpload from './ImageUpload';

const InputField = ({
    type,
    label,
    value,
    onChange,
    options = [],
    required = false,
}) => {
    const [fileData, setFileData] = useState(null);

    const handleChange = (e) => {
        console.log("change event", e);
        const val = e?.target?.value !== undefined ? e.target.value : e;
        console.log("extracted value", val);
        onChange(val);
    };

    const handleSingleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        onChange(isChecked);
    }

    const handleMultiCheckboxChange = (optionValue) => {
        const selectedValues = Array.isArray(value) ? [...value] : [];

        const valueIndex = selectedValues.indexOf(optionValue);

        if (valueIndex === -1) {
            selectedValues.push(optionValue);
        } else {
            selectedValues.splice(valueIndex, 1);
        }

        onChange(selectedValues);
    }

    const isOptionSelected = (optionValue) => {
        if(!Array.isArray(value)) return false;
        return value.includes(optionValue);
    }

    const handleDateSelected = (date) => {
        onChange(date ? date.toISOString().split('T')[0] : null);
    }

    const handleTimeChange = (e) => {
        onChange(e.target.value);
    }

    const handleDateTimeChange = (dateTime, isTime = false) => {
        if (isTime) {
            onChange({
                ...(value || {}),
                time: dateTime,
            });
        } else {
            onChange({
                ...(value || {}),
                date: dateTime,
            });
        }
    }

    console.log("InputField value", value);

    switch (type) {
        case 'Radio':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{required && <span style={{color: 'red'}}>*</span>}</T>
                    <RadioGroup
                        value={value || ''}
                        onChange={handleChange}
                    >
                        {options.map(option => (
                            <Radio
                                key={option.value}
                                value={option.value}
                                label={option.label}
                            />
                        ))}
                    </RadioGroup>
                </Box>
            );

        case 'Select':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Select
                        value={value || ''}
                        onChange={handleChange}
                        options={options}
                    >
                        {options.map(option => (
                            <Select.Option key={option.value} value={option.label}>
                                {option.label}
                            </Select.Option>
                        ))}
                    </Select>
                </Box>
            );

        case 'Number':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                        <Input
                            type="number"
                            value={value || ''}
                            onChange={handleChange}
                            required={required} 
                            textAlign="right"
                            onKeyDown={(e) => {
                                const isValid = /[0-9.]/.test(e.key) || ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(e.key);
                                if (!isValid) {
                                    e.preventDefault();
                                }
                            }}
                        />
                </Box>
            );

        case 'Checkbox':
            if (options && options.length > 0) {
                return (
                    <Box flexDirection="column" w="100%" mb={2}>
                        <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                        <Box flexDirection="column">
                            {options.map(option => (
                                <Box key={option.value} flexDirection="row" alignItems="center" mb={1}>
                                    <Checkbox
                                        checked={isOptionSelected(option.value)}
                                        onChange={() => handleMultiCheckboxChange(option.value)} 
                                    />
                                    <T ml={1}>{option.label}</T>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                );
            }
            
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <Box flexDirection="row" alignItems="center">
                        <Checkbox 
                            checked={value || false}
                            onChange={(e) => handleChange(e.target.checked)}
                            required={required}
                        />
                        <T ml={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    </Box>
                </Box>
            );
        
        // case 'File':
        //     return (
        //         <Box flexDirection="column" w="100%" mb={2}>
        //             <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
        //             <FileUpload
        //                 onChange={handleFileChange}
        //                 text={fileData ? fileData.name : 'Upload File'} 
        //             />
        //         </Box>
        //     );

        case 'Date':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <DatePicker
                        selectedDate={value ? new Date(value) : undefined}
                        onSelected={handleDateSelected}
                        showClearButton
                    >
                        {/* <Box p={2} borderWidth={1} borderColor="gray.300" borderRadius={4} bg="white">
                            {value ? new Date(value).toLocaleDateString() : 'Select Date'}
                        </Box> */}
                        <Input
                            iconRight="falCalendarAlt"
                            placeholder="Please select"
                            readOnly
                            value={value ? new Date(value).toLocaleDateString() : ''}
                            cursor="pointer"
                            />
                    </DatePicker>
                </Box>
            ); 

        case 'Time':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Input
                        type="time"
                        value={value || ''}
                        onChange={handleTimeChange}
                        required={required}
                    />
                </Box>
            );

        case 'DateTime':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Box flexDirection="column" gap={1}>
                        <DatePicker
                            selectedDate={value?.date ? new Date(value.date) : undefined}
                            onSelected={(date) => {
                                handleDateTimeChange(date ? date.toISOString().split('T')[0] : null, false)
                            }}
                            showClearButton={true}
                        >
                            <Input
                                value={value?.date ? new Date(value.date).toLocaleDateString() : ''}
                                placeholder='Select Date'
                                readOnly
                                cursor="pointer"
                            />    
                        </DatePicker>
                        <Input
                            type="time"
                            value={value?.time || ''}
                            onChange={(e) => handleDateTimeChange(e.target.value, true)}
                            required={required} 
                        />
                    </Box>
                </Box>
            );

        case 'Image':
            return (
                <ImageUpload
                    label={label}
                    value={value}
                    onChange={onChange}
                    required={required}    
                />
            );

        case 'URL':
            const [urlError, setUrlError] = useState('');
            const handleUrlChange = (e) => {
                const url = e.target.value;
                if (url && !isValidURL(url)) {
                    setUrlError('Invalid URL');
                } else {
                    setUrlError('');
                }
                handleChange(e);
            };

            const isValidURL = (string) => {
                try {
                    new URL(string);
                    return true;
                } catch (_) {
                    return false;
                }
            }; 

            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Input
                        type="url"
                        value={value || ''}
                        onChange={handleChange}
                        required={required}
                        placeholder='https://example.com' 
                    />
                    {urlError && <T color="red.500" mt={1}>{urlError}</T>}
                </Box>
            );

        case 'TextArea':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Textarea
                        value={value || ''}
                        onChange={handleChange}
                        required={required}
                        placeholder='Enter your text here...'
                        rows={4}
                    />
                </Box>
            );

        case 'Hidden':
            return null;

        case 'Password':
            const [showPassword, setShowPassword] = useState(false);

            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Box position="relative" w="100%">
                        <Input
                            type={showPassword ? 'text' : 'password'}
                            value={value || ''}
                            onChange={handleChange}
                            required={required}
                            placeholder='Enter your password'
                            pr="40px"
                        />
                    </Box>
                </Box>
            );

        case 'Color':
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Box flexDirection="row" alignItems="center" gap={2}>
                        <input
                            type="color"
                            value={value || '#000000'}
                            onChange={handleChange}
                            required={required}
                            style={{
                                width: '50px',
                                height: '38px',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }} 
                        />
                        <Input
                            value={value || '#000000'}
                            onChange={handleChange}
                            required={required}
                            placeholder='Enter color code (e.g., #ff0000)'
                            maxLength={7}
                            w="120px"
                        />
                    </Box>
                    <T fontSize="xs" color="gray.500" mt={1}>
                            Click the color box to select a color or enter a hex code.
                    </ T>
                </Box>
            );
        
        default:
            return (
                <Box flexDirection="column" w="100%" mb={2}>
                    <T mb={1}>{label}{required && <span style={{color: 'red'}}>*</span>}</T>
                    <Input
                        value={value || ''}
                        onChange={handleChange}
                        required={required}
                    />
                </Box>
            );
    }
};

export default InputField;